module.exports = "/packs/images/svg/facilities/leisure_studio~a903d9710d290861f9008da174237996.svg";